<template>
	<section class="main-content benefits">
		<div class="row">
			<div class="columns column4">
				<h2 class="subtitle">{{ subtitle }}</h2>
				<h2>{{ title }}</h2>
				<ul>
					<li v-for="(benefit, key) in benefits" :key="key">
						<span>{{ benefit }}</span>
					</li>
				</ul>
				<nuxt-link class="button button-cta reserve-now" :to="localePath('contact')" rel="noopener noreferrer">
					{{ bookButton }}
				</nuxt-link>
			</div>
		</div>
		<div class="inner-wrapper">
			<picture>
				<source v-if="image.imageWebp" :srcset="image.imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img class="fade-image" :src="image.image" :alt="image.imageAlt" loading="lazy" />
			</picture>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	bookButton: { type: String, default: '' },
	benefits: { type: Array, default: () => [] },
	image: {
		type: Object,
		default: () => ({
			image: '',
			imageAlt: '',
			imageWebp: '',
		}),
	},
});
</script>

<style lang="scss" scoped>
.benefits .fade-image {
	opacity: 1;
}

.inner-wrapper {
	position: absolute;
	inset: 0 0 90px;
}

.benefits {
	position: relative;
	padding: 125px 0 0;
}

.benefits .row {
	z-index: 2;
	position: relative;
}

.benefits .column4 {
	background: #f5f4ef;
	backdrop-filter: blur(34px);
	padding: 50px 75px;
	box-shadow: 0 14px 24px rgb(0 0 0 / 15%);
	margin: 0 auto 40px;
}

.benefits ul {
	list-style: none;
	margin: 30px 0;
	padding-left: 0;
}

.benefits li {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: flex-start;
	margin: 20px 0;

	span {
		width: calc(100% - 50px);
	}
}

.benefits li::before {
	content: '';
	background: url('~/assets/images/benefits-arrow-right.png') no-repeat center center;
	background-size: 35px;
	height: 8px;
	width: 35px;
	display: block;
	margin: 10px 20px 0 0;
}

@media (max-width: 1180px) {
	.benefits .column4 {
		width: 50%;
	}
}

@media (max-width: 920px) {
	.benefits {
		padding: 10px 10px 400px;

		.column4 {
			width: 100%;
			padding: 40px 25px;
		}
	}
}
</style>
